import { Box, Flex, ImageProps } from "@chakra-ui/react"
import { ImageModel } from "../../api-clients/product-api-v1"
import CustomImage from "./CustomImage"
import GeberitCarousel from "./Geberit/GeberitCarousel"

type Props = {
  images: ImageModel[]
  imageStyleProps?: ImageProps
}

const DIMENSIONS = { base: "70", xs: "118" }

const MobileImageGallery = ({ images, imageStyleProps }: Props) => {
  if (!images?.length) return null

  return (
    /* Show on smallest mobile breakpoint */
    <Box minH={DIMENSIONS} display={{ base: "block", sm: "none" }} mt={{ base: "-6", sm: "0" }}>
      <GeberitCarousel hideIndicator={images?.length === 1} slideMargin={24}>
        {images.map((img: ImageModel) => (
          <Flex key={img.key} alignItems="center" justifyContent="center">
            <CustomImage
              src={img?.medium}
              {...imageStyleProps}
              alt="Main gallery image"
              loading="eager"
              objectFit="contain"
              w={DIMENSIONS}
              h={DIMENSIONS}
            />
          </Flex>
        ))}
      </GeberitCarousel>
    </Box>
  )
}

export default MobileImageGallery
